import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M15.75 19H2.25C2.05109 19 1.86032 18.921 1.71967 18.7803C1.57902 18.6397 1.5 18.4489 1.5 18.25V1.75C1.5 1.55109 1.57902 1.36032 1.71967 1.21967C1.86032 1.07902 2.05109 1 2.25 1H11.25L16.5 6.25V18.25C16.5 18.4489 16.421 18.6397 16.2803 18.7803C16.1397 18.921 15.9489 19 15.75 19Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.25 1V6.25H16.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.75 13L9 15.25L11.25 13" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 1H2.25C2.05109 1 1.86032 1.07902 1.71967 1.21967C1.57902 1.36032 1.5 1.55109 1.5 1.75V18.25C1.5 18.4489 1.57902 18.6397 1.71967 18.7803C1.86032 18.921 2.05109 19 2.25 19H15.75C15.9489 19 16.1397 18.921 16.2803 18.7803C16.421 18.6397 16.5 18.4489 16.5 18.25V6.25M11.25 1L16.5 6.25M11.25 1V6.25H16.5M9 9.25V15.25M9 15.25L6.75 13M9 15.25L11.25 13",
			stroke: "#FFFFFF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFileArrowDown;
